export default "__VITE_ASSET__BYKiVABf__"